import { notAStringError } from "./common.js";

var string_interpretation = Object.freeze({
	test: function (str) {
		return typeof str === "string" ? true : notAStringError(str);
	},
	parse: function (str) {
		return typeof str === "string" ? str : notAStringError(str);
	},
	format: function (str) {
		if (typeof str === "string") return str;
	},
	type: "string",
	description: "Arbitrary string",
	id: "string$arbitrary_string",
});

export { string_interpretation };
